//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
import { hospitalCity, hospitalGrid } from '@/model/javaApi/detail.js';
import { store, mutations } from "@/observable/store";
import { location } from '@/utils/commonUtils.js'

    export default {
        data() {
            return {
                dataList:[], //机构列表
                myScroll:null,
                loading:false, // 是否加载中
                page:'1', // 当前页数
                point:{}, //当前所在位置
                initShow:false, //初次进入先不展示无数据
            }
        },
        props: {
            cityCode: {   // 城市code 
                type: [Number,String],
                default:'',
                required:true
            },
            cityName: {   // 城市name
                type: [Number,String],
                default:'',
                required:true
            }
        },
        created () {
            // new BScroll
            this.scroll()
            this.getList()
        },
        methods: {
            // 获取机构列表
            async getList(){
                // 优先根据城市获取 （'0000' = 附近）
                if(this.cityCode !== '' && this.cityCode !== '0000'){ 
                    this.hostCity()

                    this.$emit('state', {
                        state:1,
                        titleCenter:'当前城市门店',
                        titleLeft:this.cityName
                    })
                }else{
                    // 再根据定位获取机构
                    this.point = await this.getLocaPoint()
                    console.log("坐标:",this.point);
                    if(this.point.lng){
                        this.hostGrid()
                        this.$nextTick(()=>{
                            this.$emit('state', {
                                state:1,
                                titleCenter:'附近 50km 门店',
                                titleLeft:'附近',
                            })
                        })

                    // 城市与定位都拿不到则获取 北京机构
                    }else{
                        // 手动选择 ‘附近’ 
                        // if(this.cityCode == '0000'){
                        //     this.$toast("定位失败,请选择城市")
                        //     this.$emit('state', {
                        //         state:1,
                        //         titleCenter:'附近 50km 门店',
                        //         titleLeft:'附近',
                        //     })
                        //     this.initShow = true
                            
                        // 默认展示北京
                        // }else{
                            this.hostCity(1)
                            this.$emit('state', {
                                state:1,
                                titleCenter:'当前城市门店',
                                titleLeft:'北京',
                                city:{
                                    code:'1',
                                    name:'北京'
                                }
                            })
                        // }
                        
                    }
                }
            },

            // 根据城市code获取列表
            hostCity(code = ''){
                if(this.page ==  0 || this.loading) return;
                this.loading = true;
                let cityCode  = code || this.cityCode
                let params = {
                    cityCode: cityCode,
                    pageNum:this.page,
                    pageSize:20
                }
                hospitalCity(params).then(res=> {

                    this.dataList=res.records;
                    this.dataN=true;
                    this.page = res.current || 0;
                    this.$nextTick(() => {
                        this.myScroll.refresh() // DOM 结构发生变化后，重新初始化BScroll
                    })
                }).finally(()=>{
                    this.loading = false
                    this.initShow = true
                });
            },
            // 根据坐标获取列表
            hostGrid(){
                if(this.page ==  0 || this.loading) return;
                this.loading = true;
                let params = {
                    longitude: this.point.lng.toString(),
                    latitude: this.point.lat.toString(),
                    pageNum:this.page,
                    pageSize:20
                }
                hospitalGrid(params).then((res) => {
                    this.dataList=res.records;
                    this.dataN=true;
                    this.page = res.current || 0;
                    this.$nextTick(() => {
                        this.myScroll.refresh() // DOM 结构发生变化后，重新初始化BScroll
                    })
                }).finally(()=>{
                    this.loading = false
                    this.initShow = true

                });
            },
            // 获取定位
            getLocaPoint(){
                
                return new Promise((resolve, reject) => {
                    // 先回去store里的定位
                    if(store.locaPoint.lng){
                        resolve(store.locaPoint)
                    }else{
                        // 获取微信/百度定位
                        location().then( data => {
                            let point =  {
                                lng: data.point.lng,
                                lat: data.point.lat
                            }
                            mutations.locaPoint(point)
                            resolve(point)
                        }).catch(err =>{
                            console.log('定位err',err)
                            let point =  {
                                lng: '',
                                lat: ''
                            } 
                            resolve(point)
                        })
                    }
                    

                });
                
            },
            // new scroll
            scroll(){
                this.$nextTick(() => {
                    if (!this.myScroll) {
                        this.myScroll = new BScroll(this.$refs.clinicBox, {
                            click: true,
                            scrollY: true,
                            pullDownRefresh: {
                                threshold: 50,
                                probeType: 3
                            },
                            pullUpLoad: {
                                threshold: 744
                            }
                        });
                        this.myScroll.on('pullingDown', () => {
                            this.getList();
                            this.myScroll.finishPullDown() // 标识下拉动作结束。
                        })

                        this.myScroll.on('pullingUp', () => {
                            this.getList(); 
                            this.myScroll.finishPullUp() // 标识上拉动作结束。
                        })
                    }
                })
           
            },
            // 展示地图
            hostMap(item){
                this.STATISTICS_CONFIG.insur_clinicsdetail_clinicinfo_click()
                console.log(item)
                let hostPonit = {
                    lat: item.latitude,
                    lng: item.longitude
                }
                this.$emit('state', {
                    titleCenter : '门店地图',
                    titleLeft : '返回',
                    state: 3,
                    Ponit:hostPonit
                })
            },
            // 切换城市
            selectCity(){
                this.$emit('state', {
                    state:2,
                    titleCenter:'选择城市',
                    titleLeft:'返回',
                })
            }
        },
    }
